module.exports = __webpack_public_path__ + "img/icon_1.30d57218.png";